// extracted by mini-css-extract-plugin
export default {"wrapper":"ShelfNavigator_wrapper__ANFxq","select":"ShelfNavigator_select__6ei3D"};